export default __webpack_public_path__ + "static/media/element_104.5106b1ed.webp";